import { GenericError } from '@epihub/core/src/errors';
import { _isEmpty } from '@epihub/core/src/fn/object';

export function assertDefined<T>(t: T | null | undefined, scope: string = 'undefined'): NonNullable<T> {
  if (t == null) {
    throw new GenericError({
      scope: 'assert::assertDefined',
      message: scope ?? 'Expected variable to be defined',
    });
  }
  return t;
}

export function assertEqual<T>(t: T, eql: T): T {
  if (t !== eql) {
    throw new Error('not equal');
  }
  return t;
}

export function assertNever<T>(msg: string): T {
  throw new Error(`assertNever, ${msg}`);
}

export function assertNotEmpty<T>(t: T | null | undefined, scope: string = 'undefined'): NonNullable<T> {
  if (_isEmpty(t)) {
    throw new GenericError({
      scope: 'assert::assertDefined',
      message: `Expected scope(${scope}) variable to be defined`,
    });
  }
  return t as NonNullable<T>;
}
